// @file Initial (and likely static) states for surface vuex store from other imported modules (e.g. device info)
import appCan from 'bits/app_can'
import { browserCan } from 'bits/browser'
import { getCookie } from 'bits/cookie'
import getCsrfToken from 'bits/csrf_token'
import device from 'bits/device'
import window, { ww } from 'bits/global'
import { Cid } from 'types'

function getStartingExpandedPostCid(): Cid | null {
  if (window.location.pathname.split('/').length === 5) {
    return 'c' + window.location.pathname.split('/')[4]
  }
  return null
}

export default (): any => ({
  /* CONSTANTS */
  canPostMessage: appCan('postMessage'),
  cookiesEnabled: browserCan('cookiesForReal'),
  csrfToken: getCsrfToken(),
  deviceId: getCookie('ww_d'),
  dpr: Math.ceil(window.devicePixelRatio) || 1,
  environment: document.documentElement.dataset.environment,
  inlinePostEdit: !device.mobile,
  isAndroid: device.android,
  isApp: device.app,
  isChrome: device.chrome,
  isDesktop: device.desktop,
  isElectronApp: device.electronApp,
  isEdge: device.edge,
  isFirefox: device.firefox,
  isIE: device.ie,
  isIOS: device.ios,
  isIPhone: device.iphone,
  isIPhoneX: device.iphoneX,
  isMac: device.mac,
  isMobile: device.mobile,
  isMousable: device.mousable,
  isNativeMenu: appCan('showAlertSheet'),
  isOldApp: device.app && !appCan('postNatively'),
  isPhone: device.phone,
  isSafari: device.safari,
  isTablet: device.tablet,
  isTouchable: device.touchable,
  isWindows: device.windows,
  locale: document.documentElement.lang,
  modalPostEdit: device.mobile && !(device.app && appCan('postNatively')),
  nativePostEdit: device.app && appCan('postNatively'),
  release: document.documentElement.dataset.version,
  uid: ww.uid,
  xHeader: !device.app || !appCan('useNativeHeader'),

  /* MODULES */
  expandedPostCid: getStartingExpandedPostCid(),
})
